module.exports = __webpack_public_path__ + "static/media/settings.c985b0f7.svg";